import React from 'react';

interface IProps {
    overallScore: number | undefined,
    lowestScore: number | undefined,
    averageScore: number | undefined,
}

interface IELTSScoreInfo {
    label: string;
    description: string;
    studyOpportunities: string;
    immigrationOpportunities: string;
}

const ieltsScoreInfo: Record<number, IELTSScoreInfo> = {
    9: { label: 'Expert User', description: 'Has fully operational command of the language: appropriate, accurate, and fluent with complete understanding.', studyOpportunities: '✅ Top-tier Programs', immigrationOpportunities: '✅ Most Pathways' },
    8: { label: 'Very Good User', description: 'Has fully operational command of the language with only occasional unsystematic inaccuracies and inappropriacies. Misunderstandings may occur in unfamiliar situations. Handles complex detailed argumentation well.', studyOpportunities: '✅ Top-tier Programs', immigrationOpportunities: '✅ Most Pathways' },
    7: { label: 'Good User', description: 'Has operational command of the language, though with occasional inaccuracies, inappropriacies, and misunderstandings in some situations. Generally handles complex language well and understands detailed reasoning.', studyOpportunities: '✅ More Programs', immigrationOpportunities: '✅ Many Pathways' },
    6: { label: 'Competent User', description: 'Has an effective command of the language despite some inaccuracies, inappropriacies, and misunderstandings. Can use and understand fairly complex language, particularly in familiar situations.', studyOpportunities: '✅ Many Programs', immigrationOpportunities: '🔍 Some Pathways' },
    5: { label: 'Modest User', description: 'Has a partial command of the language, coping with overall meaning in most situations, though likely to make many mistakes. Should be able to handle basic communication in their own field.', studyOpportunities: '🔍 Limited', immigrationOpportunities: '❌ Unlikely' },
    4: { label: 'Limited User', description: 'Basic competence is limited to familiar situations. Has frequent problems in understanding and expression. Is not able to use complex language.', studyOpportunities: '❌ Very Limited', immigrationOpportunities: '❌ Unlikely' },
    3: { label: 'Extremely Limited User', description: 'Conveys and understands only general meaning in very familiar situations. Frequent breakdowns in communication occur.', studyOpportunities: '❌ Very Limited', immigrationOpportunities: '❌ Unlikely' },
};

const Results: React.FC<IProps> = ({ overallScore, lowestScore, averageScore }) => {

    if (!overallScore || !lowestScore) return <></>

    const overallScoreInt = Math.floor(overallScore)
    const lowestScoreInt = Math.floor(lowestScore)

    return (
        <div className="mt-8">
            <div className='w-1/2 text-2xl'>Your overall score: <b>{overallScore}</b></div>
            <div className='w-1/2 text-2xl mt-2'>Your lowest score: <b>{lowestScore}</b></div>
            <div className='w-1/2 text-sm mt-2 font-extralight'>Your average score: {averageScore}</div>

            <table className='table-auto border text-xs mt-12 max-w-100 overflow-scroll'>
                <thead>
                    <tr>
                        <th className='p-2 border'>Band (Label)</th>
                        <th className='p-2 border'>Description</th>
                        <th className='p-2 border'>📚 <br />Study</th>
                        <th className='p-2 border'>🌏 <br />Immigration</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className='p-2 border'>
                            {overallScoreInt}
                            <br />
                            {ieltsScoreInfo[overallScoreInt].label}
                        </td>
                        <td className='p-2 border'>{ieltsScoreInfo[overallScoreInt].description}</td>
                        <td className='p-2 border'>{ieltsScoreInfo[overallScoreInt].studyOpportunities}</td>
                        <td className='p-2 border'>{ieltsScoreInfo[overallScoreInt].immigrationOpportunities}</td>
                    </tr>
                    {lowestScoreInt !== overallScoreInt && (
                        <tr>
                            <td className='p-2 border'>
                                {lowestScoreInt}
                                <br />
                                {ieltsScoreInfo[lowestScoreInt].label}
                            </td>
                            <td className='p-2 border'>{ieltsScoreInfo[lowestScoreInt].description}</td>
                            <td className='p-2 border'>{ieltsScoreInfo[lowestScoreInt].studyOpportunities}</td>
                            <td className='p-2 border'>{ieltsScoreInfo[lowestScoreInt].immigrationOpportunities}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default Results;